'use client'

import clsx from 'clsx'

import S from './NewsCategoryBadge.module.scss'

type NewsCategoryBadgeProps = {
  label: string
  className?: string
}

const NewsCategoryBadge = ({ label, className }: NewsCategoryBadgeProps) => {
  return <span className={clsx(S.badge, className)}>{label}</span>
}

export default NewsCategoryBadge
